var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ml-2 points-gain",class:{
    'animate__animated lb-fadeInLeft animate__fast': !_vm.animated
  }},[_vm._v("\n  +"+_vm._s(_vm.item.newPoint)+"\n  "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.item.manualPoint),expression:"item.manualPoint"}],staticClass:"animate__animated animate__flash animate__delay-3s animate__repeat-3 animate__slow"},[_vm._v("\n    "+_vm._s(_vm.item.manualPoint > 0 ? '+' : '')+_vm._s(_vm.item.manualPoint)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }